export default function PolicyContent() {
  const sections = [
    {
      icon: 'ri-box-3-line',
      title: 'Damaged Goods',
      content: 'If your shipment arrives damaged, please notify us within 48 hours of delivery. We will arrange for inspection and provide a full refund or replacement at no additional cost. Documentation with photos is required for processing claims.',
    },
    {
      icon: 'ri-time-line',
      title: 'Timeframes',
      content: 'All return claims must be submitted within 48 hours of delivery. Claims submitted after this period may not be eligible for processing. We recommend inspecting all shipments immediately upon arrival.',
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Documentation',
      content: 'To process your return, please provide: delivery receipt, photos of damaged items, original packaging (if applicable), and a detailed description of the issue. Our team will review your submission within 24 hours.',
    },
    {
      icon: 'ri-refund-2-line',
      title: 'Refund Process',
      content: 'Once your return is approved, refunds will be processed within 5-7 business days to your original payment method. For replacement requests, we will expedite shipping at no additional charge.',
    },
  ];

  return (
    <section className="py-20 bg-[#F4E8D8]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-sm p-12">
              <div className="inline-block px-4 py-2 bg-[#F4E8D8] rounded-full text-sm font-medium text-[#3D2817] mb-8">
                Effective Date: February 2024
              </div>

              <h2 className="text-4xl font-serif font-bold text-gray-900 mb-12">
                Our Commitment to You
              </h2>

              <div className="space-y-12">
                {sections.map((section, index) => (
                  <div key={index} className="flex gap-6">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 rounded-full bg-[#F5A962] flex items-center justify-center">
                        <i className={`${section.icon} text-xl text-white`}></i>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-2xl font-serif font-bold text-gray-900 mb-3">
                        {section.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {section.content}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-white rounded-2xl shadow-lg p-8 sticky top-24">
              <h3 className="text-2xl font-serif font-bold text-gray-900 mb-6">
                Need Help?
              </h3>
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <i className="ri-mail-line text-xl text-[#E67E50] mt-1"></i>
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Email</div>
                    <a href="mailto:mark@aikinslogistics.com" className="text-sm text-gray-900 hover:text-[#E67E50] transition-colors cursor-pointer">
                      mark@aikinslogistics.com
                    </a>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-phone-line text-xl text-[#E67E50] mt-1"></i>
                  <div>
                    <div className="text-xs text-gray-500 uppercase tracking-wider mb-1">Phone</div>
                    <a href="tel:+13173972529" className="text-sm text-gray-900 hover:text-[#E67E50] transition-colors cursor-pointer">
                      +1 (317) 397-2529
                    </a>
                  </div>
                </div>
              </div>
              <a 
                href="mailto:mark@aikinslogistics.com"
                className="block w-full px-6 py-3 bg-[#E67E50] text-white text-center text-sm font-semibold rounded-full hover:bg-[#3D2817] transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
